var _defs, _ellipse, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAstronaut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 500",
    width: 400,
    height: 500,
    "aria-label": "Animated astronaut",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "halo",
    cx: "50%",
    cy: "45%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8a5cff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#6c4cfb",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6c4cfb",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "visor",
    x1: "20%",
    y1: "15%",
    x2: "80%",
    y2: "90%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#b794ff",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3d2860",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "visorShine",
    cx: "35%",
    cy: "30%",
    r: "45%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffffff",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#dcc4ff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffffff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "phoneGlow",
    cx: "50%",
    cy: "50%",
    r: "60%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#dcc4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6c4cfb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suit",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#14102099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#08050f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eyeGlow",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#dcc4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#b794ff",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softGlow",
    x: "-100%",
    y: "-100%",
    width: "300%",
    height: "300%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bigGlow",
    x: "-100%",
    y: "-100%",
    width: "300%",
    height: "300%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  })), /*#__PURE__*/React.createElement("filter", {
    id: "eyeBloom",
    x: "-100%",
    y: "-100%",
    width: "300%",
    height: "300%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  })), /*#__PURE__*/React.createElement("style", null, "\n      .astronaut {\n        animation: float 7s ease-in-out infinite;\n        transform-origin: 200px 250px;\n      }\n      @keyframes float {\n        0%, 100% { transform: translateY(0) rotate(-1.2deg); }\n        50%      { transform: translateY(-14px) rotate(1.2deg); }\n      }\n\n      .arm-right {\n        animation: armSway 5s ease-in-out infinite;\n        transform-origin: 248px 240px;\n      }\n      @keyframes armSway {\n        0%, 100% { transform: rotate(0deg); }\n        50%      { transform: rotate(4deg); }\n      }\n\n      .visor-shine {\n        animation: shine 9s ease-in-out infinite;\n        transform-origin: center;\n      }\n      @keyframes shine {\n        0%, 100% { transform: translate(0, 0); opacity: 0.55; }\n        50%      { transform: translate(14px, 10px); opacity: 1; }\n      }\n\n      .eye {\n        animation: blink 5.5s ease-in-out infinite;\n        transform-origin: center;\n        transform-box: fill-box;\n      }\n      @keyframes blink {\n        0%, 92%, 96%, 100% { transform: scaleY(1); }\n        94%                { transform: scaleY(0.08); }\n      }\n\n      .smile {\n        animation: smileFlex 4.5s ease-in-out infinite;\n        transform-origin: 200px 178px;\n      }\n      @keyframes smileFlex {\n        0%, 100% { transform: scaleY(1)   translateY(0); }\n        50%      { transform: scaleY(1.2) translateY(-1px); }\n      }\n\n      .chest-light {\n        animation: chestPulse 2.4s ease-in-out infinite;\n        transform-origin: center;\n      }\n      @keyframes chestPulse {\n        0%, 100% { opacity: 0.55; transform: scale(0.85); }\n        50%      { opacity: 1;    transform: scale(1.15); }\n      }\n\n      .antenna-tip {\n        animation: antennaBlink 3.5s ease-in-out infinite;\n        transform-origin: center;\n      }\n      @keyframes antennaBlink {\n        0%, 45%, 100% { opacity: 1; }\n        50%, 55%      { opacity: 0.25; }\n      }\n      .antenna-glow {\n        animation: antennaGlow 3.5s ease-in-out infinite;\n        transform-origin: center;\n      }\n      @keyframes antennaGlow {\n        0%, 100% { opacity: 0.6; transform: scale(1); }\n        50%      { opacity: 1;   transform: scale(1.4); }\n      }\n\n      .phone-screen {\n        animation: phoneShift 4s ease-in-out infinite;\n        transform-origin: center;\n      }\n      @keyframes phoneShift {\n        0%, 100% { opacity: 0.7; }\n        50%      { opacity: 1; }\n      }\n\n      .halo {\n        animation: breathe 6s ease-in-out infinite;\n        transform-origin: 200px 220px;\n      }\n      @keyframes breathe {\n        0%, 100% { transform: scale(1);    opacity: 0.75; }\n        50%      { transform: scale(1.06); opacity: 1; }\n      }\n\n      .sparkle {\n        animation: twinkle 3.2s ease-in-out infinite;\n        transform-origin: center;\n      }\n      .sp-1 { animation-delay: 0s;   }\n      .sp-2 { animation-delay: 0.6s; }\n      .sp-3 { animation-delay: 1.2s; }\n      .sp-4 { animation-delay: 1.9s; }\n      .sp-5 { animation-delay: 2.5s; }\n      .sp-6 { animation-delay: 0.9s; }\n      @keyframes twinkle {\n        0%, 100% { opacity: 0;   transform: scale(0.4); }\n        50%      { opacity: 0.9; transform: scale(1.1); }\n      }\n\n      .dust {\n        animation: drift 8s linear infinite;\n        opacity: 0;\n      }\n      .dust-1 { animation-delay: 0s;   }\n      .dust-2 { animation-delay: 2.5s; }\n      .dust-3 { animation-delay: 5s;   }\n      @keyframes drift {\n        0%   { opacity: 0; transform: translateY(0); }\n        20%  { opacity: 0.7; }\n        80%  { opacity: 0.4; }\n        100% { opacity: 0; transform: translateY(-80px); }\n      }\n    "))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "halo",
    cx: 200,
    cy: 220,
    rx: 180,
    ry: 170,
    fill: "url(#halo)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#dcc4ff"
  }, /*#__PURE__*/React.createElement("g", {
    className: "sparkle sp-1",
    transform: "translate(70, 130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -9 L 2 -2 L 9 0 L 2 2 L 0 9 L -2 2 L -9 0 L -2 -2 Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "sparkle sp-2",
    transform: "translate(340, 95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -6 L 1.3 -1.3 L 6 0 L 1.3 1.3 L 0 6 L -1.3 1.3 L -6 0 L -1.3 -1.3 Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "sparkle sp-3",
    transform: "translate(50, 360)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 2.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "sparkle sp-4",
    transform: "translate(355, 390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -5 L 1 -1 L 5 0 L 1 1 L 0 5 L -1 1 L -5 0 L -1 -1 Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "sparkle sp-5",
    transform: "translate(330, 230)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1.6
  })), /*#__PURE__*/React.createElement("g", {
    className: "sparkle sp-6",
    transform: "translate(85, 280)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1.3
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#b794ff"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "dust dust-1",
    cx: 120,
    cy: 430,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dust dust-2",
    cx: 280,
    cy: 440,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dust dust-3",
    cx: 200,
    cy: 450,
    r: 1.3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "astronaut"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 245,
    width: 84,
    height: 65,
    rx: 9,
    fill: "#0a0712",
    stroke: "#8a5cff",
    strokeWidth: 1.6,
    strokeOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 265,
    r: 3,
    fill: "#b794ff",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 265,
    r: 3,
    fill: "#b794ff",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 285,
    x2: 230,
    y2: 285,
    stroke: "#8a5cff",
    strokeWidth: 0.8,
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 295,
    x2: 220,
    y2: 295,
    stroke: "#8a5cff",
    strokeWidth: 0.8,
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 150 232 Q 150 222 162 222 L 238 222 Q 250 222 250 232 L 256 348 Q 256 368 236 368 L 164 368 Q 144 368 144 348 Z",
    fill: "url(#suit)",
    stroke: "#b794ff",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 222,
    x2: 200,
    y2: 278,
    stroke: "#8a5cff",
    strokeWidth: 1,
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155,
    y1: 320,
    x2: 245,
    y2: 320,
    stroke: "#8a5cff",
    strokeWidth: 1.4,
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 315,
    width: 20,
    height: 10,
    rx: 2,
    fill: "none",
    stroke: "#b794ff",
    strokeWidth: 1.2,
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 288,
    width: 44,
    height: 28,
    rx: 5,
    fill: "#0e0a18",
    stroke: "#b794ff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "chest-light",
    cx: 200,
    cy: 302,
    r: 4.5,
    fill: "#b794ff",
    filter: "url(#softGlow)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 302,
    r: 2.5,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184,
    y1: 310,
    x2: 216,
    y2: 310,
    stroke: "#8a5cff",
    strokeWidth: 0.7,
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 150 248 Q 128 275 122 318",
    fill: "none",
    stroke: "#b794ff",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 326,
    r: 11,
    fill: "#0a0712",
    stroke: "#b794ff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115,
    y1: 324,
    x2: 115,
    y2: 330,
    stroke: "#8a5cff",
    strokeWidth: 1,
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    className: "arm-right"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 250 244 Q 282 218 295 175",
    fill: "none",
    stroke: "#b794ff",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 295,
    cy: 170,
    r: 11,
    fill: "#0a0712",
    stroke: "#b794ff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 290,
    y1: 168,
    x2: 290,
    y2: 174,
    stroke: "#8a5cff",
    strokeWidth: 1,
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 138,
    width: 24,
    height: 38,
    rx: 3.5,
    fill: "#0a0712",
    stroke: "#b794ff",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "phone-screen",
    x: 291,
    y: 142,
    width: 18,
    height: 26,
    rx: 1.5,
    fill: "url(#phoneGlow)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295,
    y: 171,
    width: 10,
    height: 2,
    rx: 1,
    fill: "#b794ff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 297,
    y1: 146,
    x2: 303,
    y2: 146,
    stroke: "#0a0712",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 155,
    r: 80,
    fill: "none",
    stroke: "#b794ff",
    strokeWidth: 1.5,
    strokeOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 155,
    r: 72,
    fill: "#0a0712",
    stroke: "#b794ff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 155,
    r: 64,
    fill: "url(#visor)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "visor-shine",
    cx: 178,
    cy: 135,
    rx: 24,
    ry: 16,
    fill: "url(#visorShine)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 222,
    cy: 172,
    rx: 9,
    ry: 3.5,
    fill: "#dcc4ff",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("g", {
    className: "face"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 183,
    cy: 158,
    r: 7,
    fill: "#dcc4ff",
    fillOpacity: 0.35,
    filter: "url(#eyeBloom)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217,
    cy: 158,
    r: 7,
    fill: "#dcc4ff",
    fillOpacity: 0.35,
    filter: "url(#eyeBloom)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 170,
    cy: 172,
    rx: 6,
    ry: 3,
    fill: "#b794ff",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 230,
    cy: 172,
    rx: 6,
    ry: 3,
    fill: "#b794ff",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "eye",
    cx: 183,
    cy: 158,
    rx: 3.4,
    ry: 5.2,
    fill: "url(#eyeGlow)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "eye",
    cx: 217,
    cy: 158,
    rx: 3.4,
    ry: 5.2,
    fill: "url(#eyeGlow)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184,
    cy: 156,
    r: 1.2,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 156,
    r: 1.2,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "smile",
    d: "M 188 178 Q 200 186 212 178",
    fill: "none",
    stroke: "#dcc4ff",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeOpacity: 0.9
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 155,
    r: 64,
    fill: "none",
    stroke: "#b794ff",
    strokeWidth: 0.6,
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 144 200 Q 200 232 256 200",
    fill: "none",
    stroke: "#b794ff",
    strokeWidth: 1.5,
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 155,
    r: 3.5,
    fill: "#0a0712",
    stroke: "#b794ff",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 155,
    r: 3.5,
    fill: "#0a0712",
    stroke: "#b794ff",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 83,
    x2: 200,
    y2: 68,
    stroke: "#b794ff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "antenna-glow",
    cx: 200,
    cy: 64,
    r: 7,
    fill: "#b794ff",
    filter: "url(#bigGlow)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "antenna-tip",
    cx: 200,
    cy: 64,
    r: 3,
    fill: "#dcc4ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstronaut);
export default __webpack_public_path__ + "static/media/astronaut.78f023c09d0bd3876334655fa1b9aaf0.svg";
export { ForwardRef as ReactComponent };